// extracted by mini-css-extract-plugin
export default {"aside":"Sidebar_aside__2nUBv","help":"Sidebar_help__rig34","brand":"Sidebar_brand__WI9vB","links":"Sidebar_links__muS1D","selected":"Sidebar_selected__2Hfgc"};